/*!-----------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Version: 0.37.0-dev.20230316(a35f32ecc13a94aa3fadbef6085e983fbaf55284)
 * Released under the MIT license
 * https://github.com/microsoft/vscode/blob/main/LICENSE.txt
 *-----------------------------------------------------------*/

define("vs/base/common/worker/simpleWorker.nls.ja", {
	"vs/base/common/platform": [
		"_",
	]
});